import { initializeApp } from 'firebase/app'
import {
  getAuth,
  signInWithCustomToken,
  onAuthStateChanged,
} from 'firebase/auth'
import {
  getStorage,
  ref,
  uploadBytesResumable,
  uploadBytes,
  deleteObject,
} from 'firebase/storage'
import { nanoid } from 'nanoid'
import apiFirebaseAuth from './api/firebaseAuth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE,
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const storage = getStorage(app)
const auth = getAuth(app)

const storageApi = {}

storageApi.interviewUpload = async (
  file,
  interviewVersionId,
  questionId,
  recordingOrder,
) => {
  const fileUrl = `interview-versions/${interviewVersionId}/Q-${questionId}/Q_${questionId}_${recordingOrder}.webm`
  const fileRef = ref(storage, fileUrl)

  const uploadTask = uploadBytesResumable(fileRef, file)

  uploadTask.on(
    'state_changed',
    () => {
      // upload progress: handled via callback
    },
    (_error) => {
      // upload failed: handled via callback
    },
    () => {
      // file uploaded successfully
    },
  )

  return fileUrl
}

storageApi.uploadTest = async (file, fileUrl) => {
  const fileRef = ref(storage, fileUrl)
  const startTime = Date.now()
  await uploadBytes(fileRef, file)
  const endTime = Date.now()
  const durationInSeconds = (endTime - startTime) / 1000
  const fileSizeInMB = file.size / (1024 * 1024)
  const speedInMbps = (fileSizeInMB / durationInSeconds) * 8
  return speedInMbps
}

storageApi.deleteTest = async (file) => {
  const desertRef = ref(storage, file)
  await deleteObject(desertRef)
}

storageApi.uploadFile = (file, onUpload, onSuccess, onError) => {
  const fileExtension = file.name.split('.').at(-1)
  const fileUrl = `resumes/${nanoid(27)}.${fileExtension}`
  const fileRef = ref(storage, fileUrl)

  const uploadTask = uploadBytesResumable(fileRef, file)

  // Register three observers:
  // 1. 'state_changed' observer, called any time the state changes
  // 2. Error observer, called on failure
  // 3. Completion observer, called on successful completion
  uploadTask.on(
    'state_changed',
    (snapshot) => {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const _progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      onUpload(Math.ceil(_progress))
    },
    (_error) => {
      // Handle unsuccessful uploads
      let errorMessage = ''
      switch (_error.code) {
        case 'storage/unauthorized':
          errorMessage = 'you can only upload pdf with size less than 5 MB'
          break
        case 'storage/canceled':
          errorMessage = 'the upload has been canceled'
          break
        default:
          errorMessage = 'something went wrong please try again later'
      }
      if (onError) onError(errorMessage)
    },
    () => {
      // Handle successful uploads on complete
      if (onSuccess) onSuccess(fileUrl)
    },
  )
  return uploadTask.then(() => fileUrl)
}

const uid = 'candidate'

apiFirebaseAuth.getCustomToken(uid).then((customToken) => {
  signInWithCustomToken(auth, customToken)
    .then()
    .catch(() => {
      // Error signing in with custom token
    })
})

onAuthStateChanged(auth, (user) => {
  if (user) {
    // User is authenticated
  } else {
    // User is not authenticated
  }
})

export default storageApi
